import { Grid, Link } from "@mui/material";
import React, { useState } from "react";


const DashboardMenuForDesktop = (props) => {
   
    return(
        <div className="px-3 d-flex" style={{justifyContent: "space-between",flexDirection: 'column', minHeight: 'calc(100vh - 60px)'}}>
            <div>
                <Link href="/" className="d-block mt-2">
                    <img src={props.siteLogo} className="img-fluid mb-5" style={{width: '100%', height: 'auto', maxWidth: 220}} />
                </Link>
                <Link 
                    href="/dashboard" 
                    className={"Global---menu-link hover px-3 py-2 mb-3 borders d-block text-left px-3 px-md-4 "}>
                    <span class="material-icons md-10">store</span> Dashboard 
                </Link>
                
                <Link 
                    href="/rewards" 
                    className={"Global---menu-link hover px-3 py-2 mb-3 borders d-block text-left px-3 px-md-4 active" }>
                    <span class="material-icons md-10">savings</span> Rewards 
                </Link>
                
                <Link href="/nfts" className={"Global---menu-link hover px-3 py-2 mb-3 borders d-block text-left px-3 px-md-4 "}>
                    <span class="material-icons md-10">store</span> NFTS 
                </Link>
                
                <Link 
                    href="https://www.dextools.io/app/bsc/pair-explorer/0x305dd2595f8877c0ffaf762999e1b1153355fbba"
                    target="_blank" 
                    className={"Global---menu-link hover px-3 py-2 mb-3 borders d-block text-left px-3 px-md-4 "}>
                    <span class="material-icons md-10">store</span> Chart 
                </Link>
                
                <Link 
                    href="https://pancakeswap.finance/swap?outputCurrency=0xBa8d9B8F138EE5269A5C23339775510D050b75C1"
                    target="_blank"
                    className={"Global---menu-link hover px-3 py-2 mb-3 borders d-block text-left px-3 px-md-4 "}>
                    <span class="material-icons md-10">store</span> Buy Now 
                </Link>
                <Link href="https://game.metasnooker.io/" className={"MS---Neon--Button btn text-center hover px-3 py-2 mb-3 borders d-block text-left px-3 px-md-4 "}>
                    Play Now 
                </Link>
            </div>
        </div>
    );
}

export default DashboardMenuForDesktop;